import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { CLIENT_ALLOWANCE_EDIT } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import { Edit } from 'jbc-front/components/icons';
import { currency, numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import { toDisplayFormat } from 'src/utils/Completion';
import styles from './AllowanceRow.scss';

const allowanceEditUrl = allowance =>
  concatParamsToUrl(CLIENT_ALLOWANCE_EDIT, {
    allowanceId: allowance.id,
    payrollRulesGroupId: allowance.clientPayrollRulesGroupId
  });

const judgmentStrOrNum = displayFormulaDescription => {
  if (!_.isNaN(displayFormulaDescription) && _.isFinite(Number(displayFormulaDescription))) {
    return currency(numberWithComma(decimalPlace2(displayFormulaDescription)));
  }
  return displayFormulaDescription;
};

const AllowanceRow = ({ allowance, isSemiMonthly }) => {
  const { t } = useTranslation();
  const isSemiMonthlyAllowance = isSemiMonthly && allowance.allowanceAmountType === 'fixed';

  return (
    <tr>
      <td className={allowance.isInDisuse ? styles.through : ''}>{allowance.name}</td>
      <td className={allowance.isInDisuse ? styles.through : ''}>
        {isSemiMonthlyAllowance ? (
          <>
            {t('features.PayrollRulesGroups.containers.AllowanceRow.first_half')}
            {judgmentStrOrNum(allowance.allowanceAmount)}
            <br />
            {t('features.PayrollRulesGroups.containers.AllowanceRow.second_half')}
            {judgmentStrOrNum(allowance.allowanceAmountSecondHalf)}
          </>
        ) : (
          <>{judgmentStrOrNum(allowance.displayFormulaDescription)}</>
        )}
      </td>
      <td>
        <div className={styles.icons}>
          <span>
            {allowance.isEditable && (
              <a href={allowanceEditUrl(allowance)}>
                <Edit size={18} />
              </a>
            )}
          </span>
        </div>
      </td>
    </tr>
  );
};

export default AllowanceRow;
